import React from 'react';
import PropTypes from 'prop-types';
import { FDAlert, FDBox } from '@facet-wealth/design';

const NoRiskToleranceAlert = ({ value }) => {
  return (
    <FDBox paddingY={2}>
      <FDAlert title={value} />
    </FDBox>
  );
};

NoRiskToleranceAlert.propTypes = {
  value: PropTypes.string.isRequired,
};

export default NoRiskToleranceAlert;
